import {generateUUID} from "../../../services/misc";
/**
 * AddPracticeRecordRequest - the main content (minus session id and session token) that is sent to the api when add practice record is called.
 */
export default class AddPracticeRecordRequest {
  id?: number;
  guid?: string;
  lessonId: number;
  progress: number;
  noteScore: number;
  scorePercentage: number;
  hands: string;
  recorded: boolean;
  duration: number;
  missedNotes: number;
  longestStreak: number;
  starScore: number;
  rhythmInAccNotes: number;
  date: number; // e.g. 1556812173
  wrongNotes: number;
  tempo: number;
  bonusScore: number;
  rhythmAccNotes: number;
  segmentId: number;
  metronome: boolean;
  mode: string; //e.g. practice
  totalNotes: number;
  difficulty: number;
  totalScore: number;
  constructor({ id=0, guid=generateUUID(), lessonId, progress, noteScore, scorePercentage, hands, recorded, duration, missedNotes, longestStreak, starScore, rhythmInAccNotes, date, wrongNotes, tempo, bonusScore, rhythmAccNotes, segmentId, metronome, mode, totalNotes, difficulty, totalScore, }: AddPracticeRecordRequest) {
    Object.assign(this, { lessonId, progress, noteScore, scorePercentage, hands, recorded, duration, missedNotes, longestStreak, starScore, rhythmInAccNotes, guid, date, wrongNotes, tempo, bonusScore, rhythmAccNotes, id, segmentId, metronome, mode, totalNotes, difficulty, totalScore, });
  }
}
